import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DesktopAgentService } from 'app/services/desktop-agent.service';


@Component({
    selector: 'desktop-agent-detect-dialog',
    templateUrl: './desktop-agent-detect-dialog.component.html',
    standalone: true,
    imports: [CommonModule],
})
export class DesktopAgentDetectDialogComponent {
    constructor(public desktopAgentService: DesktopAgentService) {}
}
